import React, { useEffect, useRef, useState } from 'react'
import { FeedDimensions } from './shared'
import { Theme, variantProvider } from '@/app'

export const ScrollWrapper = ({ children }) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const [isOutOfHeight, setIsOutOfHeight] = useState(false)

  useEffect(() => {
    if (contentRef.current) {
      const height = FeedDimensions.getHeightNumber() - Theme.spacing.value(12)
      const contentHeight = contentRef.current.clientHeight
      setIsOutOfHeight(contentHeight > height)
    }
  }, [])

  return (
    <div css={[styles.wrapper, !isOutOfHeight && styles.wrapperCenter]}>
      <div style={{ width: '100%' }} ref={contentRef}>
        {children}
      </div>
    </div>
  )
}

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    display: 'block',
    overflowY: 'auto',
    zIndex: 1,
    width: FeedDimensions.WIDTH,
    height: FeedDimensions.HEIGHT,
    ...theme.spacing.paddingHorizontal(2),
    ...theme.spacing.paddingVertical(6),

    [theme.media.down(FeedDimensions.mobileBreakpoint)]: {
      width: FeedDimensions.WIDTH_WITHOUT_SPACING,
      height: FeedDimensions.HEIGHT_WITHOUT_SPACING,
    }
  },
  wrapperCenter: {
    display: 'flex',
    ...theme.presets.center,
  }
}), true)